(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const initialized = new WeakSet();

  const setExpanded = (details, expanded) => {
    details.open = expanded;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(expanded));
  };

  const closeSiblings = (current) => {
    const currentItem = current.closest('li');
    const siblingList = currentItem?.parentElement;
    siblingList
      ?.querySelectorAll(':scope > li > details[open], :scope > li > header-menu > details[open]')
      .forEach((details) => {
        if (details !== current) setExpanded(details, false);
      });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (initialized.has(details)) return;
      initialized.add(details);

      let closeTimer;
      const open = () => {
        if (!desktop.matches) return;
        window.clearTimeout(closeTimer);
        closeSiblings(details);
        setExpanded(details, true);
      };
      const close = () => {
        if (!desktop.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            setExpanded(details, false);
          }
        }, 180);
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', close);
    });
  };

  const closeDesktopMenus = () => {
    document.querySelectorAll('.header__inline-menu details[open]').forEach((details) => {
      setExpanded(details, false);
    });
  };

  desktop.addEventListener('change', (event) => {
    if (!event.matches) closeDesktopMenus();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
})();